import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockGaugeChartComponent } from './block-gaugeChart.component';
import { GaugeChartModule } from '@app/components/gaugeChart/gaugeChart.module';

@NgModule({
  imports: [CommonModule, SharedModule, GaugeChartModule],
  declarations: [BlockGaugeChartComponent],
  exports: [BlockGaugeChartComponent],
})
export class BlockGaugeChartModule {}
